/**
 * Selects the last element of an array.
 */
// TODO: Add  support for `Map` and `Set`
export function last(arr) {
    return arr.at(arr.length - 1);
}
/**
 * Selects the first element of an array.
 */
// TODO: Add  support for `Map` and `Set`
export function first(arr) {
    return arr.at(0);
}
/**
 * Creates a selector that retrieves a property from an object.
 */
export function property(key) {
    return (obj) => obj[key];
}
/**
 * Creates a selector that counts the number of elements
 * in an array or entries in a set or map.
 */
export function count(value) {
    return "length" in value ? value.length : value.size;
}
/**
 * Creates a selector that retrieves the largest element
 * in an array.
 */
// TODO: Add  support for `Map` and `Set`
export function max(values) {
    return values.reduce((r, c) => (r === undefined || Number(c) > Number(r) ? c : r), undefined);
}
/**
 * Creates a selector that retrieves the smallest element
 * in an array.
 */
// TODO: Add  support for `Map` and `Set`
export function min(values) {
    return values.reduce((r, c) => (r === undefined || Number(c) < Number(r) ? c : r), undefined);
}
/**
 * Creates a selector that retrieves the largest element
 * in an array based on a specified property.
 */
// TODO: Add  support for `Map` and `Set`
export function withMaxBy(k) {
    return (v) => v.reduce((r, c) => (r === undefined || Number(c[k]) > Number(r[k]) ? c : r), undefined);
}
/**
 * Creates a selector that retrieves the smallest element
 * in an array based on a specified property.
 */
// TODO: Add  support for `Map` and `Set`
export function withMinBy(k) {
    return (v) => v.reduce((r, c) => (r === undefined || Number(c[k]) < Number(r[k]) ? c : r), undefined);
}
/**
 * Creates a selector that filters an array based on a predicate function.
 */
// TODO: Add  support for `Map` and `Set`
export function withFilter(predicate) {
    return (arr) => arr.filter(predicate);
}
